// This file ensures video.js is loaded and available globally before any plugins
import videojs from 'video.js';

// Make videojs available globally
window.videojs = videojs;

// Export for use in other modules
export default videojs;